"use strict";

var regexValidator = require('./regexValidator');

var _require = require('./errors'),
    InvalidIdError = _require.InvalidIdError;

var idRegex = /^[a-z0-9-]{36}$/;
var validator = regexValidator(idRegex, InvalidIdError);

module.exports = function () {
  return {
    validate: function validate(page) {
      return validator.validate(page);
    }
  };
};
//# sourceMappingURL=idValidtor.js.map